import { render, staticRenderFns } from "./OrderSupplierRequestsReport.vue?vue&type=template&id=f5a9933a&"
import script from "./OrderSupplierRequestsReport.vue?vue&type=script&lang=js&"
export * from "./OrderSupplierRequestsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports